module.exports = __webpack_public_path__ + "media/images/illustration/undraw_buy_house_560d-a4c0a4a76516bccaa7e77ee10f4d7875.svg";